import {
  clearSearchInput,
  searchOnChange,
  showHeaderSearchBar,
} from "./functions/headerSearch";
import "../styles/main.scss";
import FAQAction from "./functions/FAQAction";
import SmoothScroll from "./functions/smoothScroll";
import { gtmClickAction } from "./functions/gtmClickAction";
import { promoDividerClick } from "./functions/promoDividerClick";
import Cookies from "js-cookie";
import { addYears } from "date-fns";
import { generateQrCode } from "./functions/qrcodeGenerator";
import { changePricingPlanTab } from "./functions/pricingPlanFunctions";
import { detectColor } from "./functions/detectColor";

window.showHeaderSearchBar = showHeaderSearchBar;
window.clearSearchInput = clearSearchInput;
window.searchOnChange = searchOnChange;
window.promoDividerClick = promoDividerClick;
const NEXT_PUBLIC_COOKIE_DOMAIN = window.seplayApiNonce.domainName;
const cookieSetOptions = {
  domain: NEXT_PUBLIC_COOKIE_DOMAIN ?? "",
  httpOnly: false,
  expires: addYears(Date.now(), 1), // 1 year
  sameSite: "lax",
};

type UTMParams = {
  [key: string]: string | null;
};

function getUtmParamsFromUrl(): UTMParams {
  const params = new URLSearchParams(document.location.search);
  const list: UTMParams = {};
  window.utmParameters.data?.map((key: string) => {
    list[key] = params.get(key);
  });
  return list;
}

function addUtmParamsToLinks(data: UTMParams) {
  const links = document.querySelectorAll(
    'a[href*="sportsengineplay.com"]',
  ) as NodeListOf<HTMLLinkElement>;

  links?.forEach((link) => {
    const url = new URL(link.href); // Create a URL object from the href
    window.utmParameters.data?.map((key: string) => {
      if (data[key]) {
        url.searchParams.set(key, data[key]);
      }
    });
    // Update the href with modified UTM parameters
    link.href = url.toString();
  });
}

function saveUtmCookies() {
  const data = getUtmParamsFromUrl();
  addUtmParamsToLinks(data);
  if (data["utm_source"] && data["utm_medium"] && data["utm_campaign"]) {
    Cookies.set("x-campaign-name", data["utm_campaign"], cookieSetOptions);
    Cookies.set("x-campaign-source", data["utm_source"], cookieSetOptions);
    Cookies.set("x-campaign-medium", data["utm_medium"], cookieSetOptions);
  }
}

function convertDateFromUTCToLocalTime() {
  const dates = document.querySelectorAll("[data-utc-time]");
  dates.forEach((selector) => {
    if (selector) {
      const utcDate = selector.getAttribute("data-utc-time");
      const date = new Date(utcDate);
      selector.innerHTML = date.toLocaleTimeString([], {
        hour: "2-digit",
        minute: "2-digit",
      });
    }
  });
}

async function getCountry(): Promise<{ country: string }> {
  const response = await fetch("https://ipapi.co/json/");
  return response.json();
}

function showFooterCheckIcon() {
  const country = getCountry();
  country.then((data) => {
    if (data?.country == "US") {
      const icon = document.querySelector(".us-check-icon") as HTMLDivElement;
      icon.classList.remove("hidden-icon");
      const text = icon.getAttribute("data-us-text") as string | undefined;
      if (text) {
        icon.innerText = text;
      }
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
  FAQAction();
  SmoothScroll();
  gtmClickAction();
  saveUtmCookies();
  generateQrCode();
  convertDateFromUTCToLocalTime();
  changePricingPlanTab();
  if (window.Swiper) {
    new window.Swiper("#channel-logos", {
      slidesPerView: 1,
      spaceBetween: 10,
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        993: {
          slidesPerView: 2,
        },
        1100: {
          slidesPerView: 3,
        },
        1200: {
          slidesPerView: 4,
        },
      },
    });
    const channelsSliders = document.querySelectorAll(
      ".channels-carousel",
    ) as NodeListOf<HTMLDivElement>;
    if (channelsSliders) {
      channelsSliders.forEach(function (slider) {
        const id = slider.getAttribute("id");
        new window.Swiper(`#${id} .channels-carousel-slider`, {
          slidesPerView: 2,
          spaceBetween: 10,
          navigation: {
            nextEl: `#${id} .carousel-btn-next`,
            prevEl: `#${id} .carousel-btn-prev`,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
            },
            993: {
              slidesPerView: 3,
            },
            1100: {
              slidesPerView: 4,
            },
            1350: {
              slidesPerView: 5,
            },
          },
        });
      });
    }

    const featuredChannelsCarousel = document.querySelectorAll(
      ".featured-channels-carousel",
    ) as NodeListOf<HTMLDivElement>;
    if (featuredChannelsCarousel) {
      featuredChannelsCarousel.forEach(function (slider) {
        const id = slider.getAttribute("id");
        const images = slider.querySelectorAll(
          ".featured-channels-carousel-slider-slide-image",
        ) as NodeListOf<HTMLImageElement>;
        images.forEach(function (image) {
          const color = detectColor(image);
          image.parentNode.style.backgroundColor = color;
        });
        new window.Swiper(`#${id} .featured-channels-carousel-slider`, {
          slidesPerView: 2,
          spaceBetween: 10,
          navigation: {
            nextEl: `#${id} .carousel-btn-next`,
            prevEl: `#${id} .carousel-btn-prev`,
          },
          breakpoints: {
            640: {
              slidesPerView: 2,
            },
            993: {
              slidesPerView: 3,
            },
            1100: {
              slidesPerView: 4,
            },
            1350: {
              slidesPerView: 5,
            },
          },
        });
      });
    }

    new window.Swiper(`#pricing-plans-slider`, {
      centeredSlides: true,
      spaceBetween: 8,
      initialSlide: 1,
      width: 350,
      navigation: {
        nextEl: `.pricing-plans-slider-btn-next`,
        prevEl: `.pricing-plans-slider-btn-prev`,
      },
      pagination: {
        el: ".pricing-plans-slider-pagination",
        clickable: true,
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          width: null,
        },
        992: {
          width: null,
          centeredSlides: false,
          slidesPerView: 3,
        },
      },
    });

    const sliderCarousel = document.querySelectorAll(
      ".slider-carousel",
    ) as NodeListOf<HTMLDivElement>;
    if (sliderCarousel) {
      sliderCarousel.forEach(function (slider) {
        const id = slider.getAttribute("id");
        const slides = document.querySelectorAll(`#${id} .slider-slide`);
        if (slides.length <= 3) {
          const wrapper = document.querySelector(`#${id} .slider-wrapper`);
          const clone =
            slides[Math.floor(Math.random() * slides.length)].cloneNode(true);
          wrapper?.appendChild(clone);
        }
        new window.Swiper(`#${id} .slider`, {
          effect: "coverflow",
          loop: true,
          centeredSlides: true,
          grabCursor: true,
          slidesPerView: "auto",
          coverflowEffect: {
            rotate: 0,
            stretch: 70,
            scale: 1,
            depth: 100,
            modifier: 3,
            slideShadows: true,
          },
          navigation: {
            nextEl: `#${id} .slider-navigation-next`,
            prevEl: ` #${id} .slider-navigation-prev`,
          },
          pagination: {
            el: `#${id}.slider-pagination`,
            clickable: true,
          },
        });
      });
    }
  }

  showFooterCheckIcon();
});
